import { FormGroup } from '@blueprintjs/core'
import React, { Component } from 'react'

import { isPresent, SimpleSlider, SimpleSliderProps } from '../../app/shared' // FIXME: this is not good

import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

import { FieldAdapterProps, SliderProps } from './types'

type Props = FieldAdapterProps<SliderProps & SimpleSliderProps>

class AdvancedSliderAdapter extends Component<Props> {
  render() {
    const { input, meta, label, helperText, disabled, required, intent, translate = identity, ...props } = this.props

    const { id, labelText } = createLabelWithId(input, label)
    const helperTextMessage = createHelperText(meta, helperText, translate)
    const labelInfo = createRequiredLabel(required, translate)
    const intentType = getIntent(meta, intent)

    return (
      <FormGroup
        className={labelInfo ? 'required' : ''}
        helperText={helperTextMessage}
        label={labelText}
        labelFor={id}
        labelInfo={labelInfo}
        intent={intentType}
        disabled={disabled}
      >
        <SimpleSlider {...props} onChange={this.handleOnChange} translate={translate} />
      </FormGroup>
    )
  }

  private handleOnChange = (value: number) => {
    const { onChange, input } = this.props

    if (isPresent(onChange)) {
      onChange && onChange(value)
    }

    input.onChange(value)
  }
}

export { AdvancedSliderAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/advanced-slider-adapter.tsx